var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    width: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2l6 6 6-6",
    fill: "none",
    stroke: "#afafb1",
    strokeLinecap: "square",
    strokeWidth: 2
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjEwIiB2aWV3Qm94PSIwIDAgMTYgMTAiIHdpZHRoPSIxNiI+PHBhdGgKICAgIGQ9Im0yMjYgMjEgNiA2IDYtNiIKICAgIGZpbGw9Im5vbmUiCiAgICBzdHJva2U9IiNhZmFmYjEiCiAgICBzdHJva2UtbGluZWNhcD0ic3F1YXJlIgogICAgc3Ryb2tlLXdpZHRoPSIyIgogICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIyNCAtMTkpIgogIC8+PC9zdmc+Cg==";
export { SvgArrowDown as ReactComponent };